import { AssociationsService } from 'app/services/associations/associations.service';
import { Component, OnInit } from '@angular/core';
import {DataTableField} from '../../../modules/UIKit/components/dataTable/dataTableField.interface';
import {Application} from '../../../models/application.model';
import {ApplicationService} from '../../../services/application/applications.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  providers: [],
  templateUrl: 'applications.component.html'
})

export class ApplicationComponent implements OnInit {

  showDetail: boolean;
  applicationsListTitles: DataTableField[];
  newDataAvailable = false;
  applications: Application[];
  selectedApplication: Application = null;
  modalTitle = '';
  labels = {}
  application: Application;
  showAssociateDialog = false;

  constructor(
    private srvApplication: ApplicationService,
    private translate: TranslateService,
    private associationsService: AssociationsService
  ) {
  }

  ngOnInit(): void {

    this.translate.get([
      'applicationList.add_title',
      'applicationList.edit_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['applicationList.add_title'];
      this.labels['edit_title'] = res['applicationList.edit_title'];
    });

    this.translate.get(['common.name', 'common.description']).subscribe((res) => {
      this.applicationsListTitles = [
        { id: 'id', label: '#'},
        { id: 'name', label: res['common.name']},
        { id: 'descr', label: res['common.description']}
      ];
    });
    this.refresh();
  }

  refresh() {
    this.srvApplication.getAll().subscribe((res) => {
      this.newDataAvailable = true;
      this.applications = res;
    });
  }

  applicationAdded(event): void {
    this.srvApplication.post(event).subscribe(() => {
      this.refresh();
    });
    this.showDetail = false;
  }

  applicationUpdated(event): void {
    this.srvApplication.put(event).subscribe(() => {
      this.refresh();
    });
    this.showDetail = false;
  }

  delete(record): void {
    this.srvApplication.delete(record).subscribe( () => {
      this.refresh();
    });
  }

  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.selectedApplication = data == null ? new Application() : data;
    this.showDetail = true;
  }

  closeDialog () {
    this.modalTitle = '';
    this.showDetail = false;
    this.selectedApplication = null;
  }

  openAssociate(row: Application) {
    this.associationsService.rowId = row.id;
    this.application = row;
    this.showAssociateDialog = true;
  }
}




// WEBPACK FOOTER //
// ./src/app/views/administration/application/applications.component.ts